import React from 'react';
import { Redirect } from 'react-router-dom';

// Orders Dashboard
import MainOrdersDashboard from '../pages/OrdersDashboard';

//Dashboard
import Dashboard from '../pages/Dashboard/index';
import Dashboardd from '../pages/Dashboardd/index';
import OrderDashboard from '../pages/Orders/components/dashboard';

//Orders

import Orders from '../pages/Orders/index';
import OrderDetails from '../pages/Orders/details';
import DeleteOrderDetails from '../pages/Orders/components/OrderDeleteDetail';
import DeleteOrders from '../pages/Orders/components/DeleteIndex';
import cncOrders from '../pages/Orders/ManageCncOrderindex';
import cncDetails from '../pages/Orders/ManageCncOrderDetail';
import ReturnOrders from '../pages/Orders/ReturnOrderindex';
import ReturnStoreOrders from '../pages/Stores/ReturnStoreIndex';

import ReturnApprovedOrders from '../pages/Orders/ReturnApprovedOrderindex';
import ReturnMarketplace from '../pages/Orders/components/return/ReturnMarketplaceindex';

import ReturnDetails from '../pages/Orders/ReturnDetails';
import ReturnMarketDetails from '../pages/Orders/ReturnMarketDetails';

import splitOrders from '../pages/Orders/splitorderindex';
import ReviewRatingDetail from '../pages/Reviews/ReviewDetail';
import b2bOrders from '../pages/Orders/b2bindex';
import installOrders from '../pages/Orders/b2bindex';
import bulkOrders from '../pages/Orders/ManageBulkOrderIndex';
import bulkDetails from '../pages/Orders/bulkDetails';
import marketplaceOrders from '../pages/MarketPlace/MarketplaceOrderindex';
import marketplaceSplitOrders from '../pages/MarketPlace/MarketplaceSplitOrderindex';
import stOrders from '../pages/MarketPlace/STOrderindex';

import MarketDetail from '../pages/MarketPlace/MarketDetail';
import MarketSplitDetail from '../pages/MarketPlace/MarketSplitDetail';

import carrefourOrders from '../pages/MarketPlace/CarrefourOrderindex';
import CarrefourSplitDetail from '../pages/MarketPlace/CarrefourSplitDetail';

import ImportOrders from '../pages/MarketPlace/ImportOrder';
import ImportReturnOrders from '../pages/MarketPlace/ImportReturnOrder';

import MailSettings from '../pages/Settings/MailsettingsForm';
import TemplateSettings from '../pages/Settings/TemplateSettings';
import ManageSettings from '../pages/Settings/ManageSettingsIndex';
import DeliverySettings from '../pages/Settings/DeliverySettings';
import CustomerTracking from '../pages/bccwOrders/CustomerTrackingIndex';
import Photoshoot from '../pages/PhotoShoot/ManageProductShootIndex';
import PhotoDetails from '../pages/PhotoShoot/Photodetail';
import MarketplaceDashboard from '../pages/MarketPlace/components/dashboard';
import TrackingDetails from '../pages/bccwOrders/TrackingDetail';
import NonServicesAreaForm from '../pages/Orders/components/NonPlanningorders/NonServiceAreaForm';
import AddCustomerForm from '../pages/Customers/AddCustomerForm';
import AddCustomerFormDetail from '../pages/Customers/AddCustomerFormDetail';
import AddCustomerEditForm from '../pages/Customers/EditAddressForm';
import UserForm from '../pages/Permissions/components/UserForm';
import EditUserForm from '../pages/Permissions/components/EditUserForm';
import KnowledgeBaseCategory from '../pages/Categories';
import AddNewCategoryForm from '../pages/Categories/components/AddNewCategory';
import KnowledgeBaseArticles from '../pages/Articles';
import AddNewArticle from '../pages/Articles/components/AddNewArticles';
import KbUpdateCategoryForm from '../pages/Categories/components/KBCategoryUpdateForm';
import EditNewArticle from '../pages/Articles/components/EditArticleDetail';
import KBDepartments from '../pages/KbDepartments';
import ImportExport from '../pages/ImportExport';
import LsStockSkuList from '../pages/ImportExport/LsStockSkuIndex';

import DeliveryReport from '../pages/Orders/DeliveryReport';
import DeliveryReportUpload from '../pages/Orders/DeliveryReport/import';
import QaOrders from '../pages/Orders/QaOrders';

import Quotations from '../pages/Orders/Quotations';

import OrderCreate from '../pages/Orders/Cart';
//returns
import Returns from '../pages/Returns/index';
//import ReturnDetails from "../pages/Returns/details";
import CreateFormReturn from '../pages/Orders/components/return/CreateNewReturn';
import CreateFormStoreReturn from '../pages/Stores/CreateFormStoreReturn';
import CreateCstReturnWarehouse from '../pages/Orders/components/return/CreateCstReturnWarehouse';
import CreateFormReturnWarehouse from '../pages/Orders/components/return/CreateNewReturnWarehouse';

//Calendar
import Calendar from '../pages/Calendar/index';

import Permissions from '../pages/Permissions/index';
import UserRoleList from '../pages/Permissions/User';

import Callback from '../pages/Callback/CallbackIndex';
import Callbackdetail from '../pages/Callback/Callbackdetail';

import ManageRiverHillOrders from '../pages/Orders/ManageRiverHillOrderIndex';
import RiverHillOrderDetail from '../pages/Orders/ManageRiverHillOrderDetail';
import DesignYourHomeLead from '../pages/Orders/DesignYourHomeLeadIndex';
import HomeLeadDetails from '../pages/Orders/DesignYourHomeLeadDetail';

// Authentication related pages
import userProfile from '../pages/Authentication/user-profile';
import Login from '../pages/Authentication/Login';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';
import LockScreen from '../pages/Authentication/LockScreen';
import ForgetPwd from '../pages/Authentication/ForgetPassword';

import NonPlanningOrder from '../pages/Orders/ManageNonPlanningOrderIndex';
import NonServiceArea from '../pages/Orders/ManageNonServiceAreaIndex';

import Queue from '../pages/Queuess/ManageQueueIndex';
import RejectedQueue from '../pages/Queuess/ManageQueueRejectedIndex';

import QueueReturn from '../pages/Queuess/ManageQueueReturnIndex';

import ApprovalRefund from '../pages/Queuess/ManageRefundApproval';
import NotificationManager from '../pages/Queuess/NotificationManager';

import ContactsProfile from '../pages/Contacts/ContactsProfile/contacts-profile';
import Reports from '../pages/reports';
import NewRoleForm from '../pages/Permissions/components/NewRoleForm';
import EditNewRole from '../pages/Permissions/components/EditNewRole';
import StoreConfig from '../pages/Orders/StoreConfigIndex';
import AllCustomer from '../pages/Customers/AllCustomersIndex';
import ClickandCollectList from '../pages/Permissions/ClickandCollectList';
import ClickandCollect from '../pages/Permissions/ClickandCollect';
import ClickandCollectForm from '../pages/Permissions/ClickandCollectForm';
import Reviews from '../pages/Reviews/ReviewsIndex';
import OrderLogReport from '../pages/Orders/components/LogFile';
import ProductsFeedback from '../pages/Products/ProductsFeedBackIndex';
import ProductFeedbackDetail from '../pages/Products/ProductsFeedBackDetails';
import AddNewDepartment from '../pages/KbDepartments/components/AddDepartment';
import EditDepartment from '../pages/KbDepartments/components/EditDepartment';
import NotificationSettings from '../pages/Settings/Notification/index';
import ImageTools from '../pages/Tools/ImageTools';
import ManageInvoices from '../pages/Invoices';
import ImportInstallationOrders from '../pages/MarketPlace/ImportInstallationOrder';
import installationorders from '../pages/Orders/ManageInstallationindex';

import Wallet from '../pages/Wallet';
import ExportedReports from '../pages/ExportedReports/ExportedReportIndex';
import CreateQuotation from '../pages/Orders/Quotations/create';
import kioskOrders from '../pages/Orders/kisokOrderList';
import CsCoupons from '../pages/CsCoupons/index';
import OrderRefunds from '../pages/Refunds/OrderRefunds';
import BankRefunds from '../pages/Refunds/BankRefunds';
import WishlistIndex from '../pages/Wishlist/WishlistPage';
import { components } from 'react-select';
import StoreOrders from '../pages/Orders/StoreOrder';
import StoreRefunds from '../pages/Refunds/StoreRefunds';
import ManageComplaints from '../pages/Complaints/ManageComplaints';
import PaymentFailedOrders from '../pages/PaymentFailedOrders';
import CodReturnOrders from '../pages/CodReturnOrders';
import ReturnDashboard from '../pages/Returns/components/dashboard';
import ComplaintDetails from '../pages/Complaints/ManageComplaints/components/ComplaintDetails';
import ComplaintsDoPage from '../pages/ComplaintsDo/ComplaintsDoPage';
import ComplaintsDoList from '../pages/ComplaintsDo/ComplaintsDoList';
import ServiceOrderDashboard from '../pages/ServiceOrders/Dashboard';
import ManageServiceOrders from '../pages/ServiceOrders/ManageServiceOrders';
import ServiceOrdersDetails from '../pages/ServiceOrders/ManageServiceOrders/components/ServiceOrdersDetails';
import ServiceItemMaster from '../pages/ServiceOrders/ServiceItemMaster';
import NonSaleApprovals from '../pages/ServiceOrders/NonSaleApprovals';
import AdvancePostingListIndex from '../pages/AdvancePosting/List';
import PremiumCareListIndex from '../pages/PremiumCare/List';
import ManageDonationsList from '../pages/Donations/ManageDonations';
import ManageTO from '../pages/ServiceOrders/ManageTO';
import ManageTechnicians from '../pages/ServiceOrders/ManageTechnicians';
import ServiceFeedback from '../pages/ServiceOrders/ServiceFeedback';
import ManagePurifierOrders from '../pages/PurifierOrders';
import HolidayCalendar from '../pages/HolidayCalendar';
import DriverAnalysis from '../pages/DriverAnalysis';

// Resolve the default landing page based on the logged-in user's role.
// Role 51 is restricted to the Service Orders dashboard, role 58 to the orders list.
const getDefaultDashboard = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    if (authUser?.role_id === '51') {
      return '/service-orders/dashboard';
    }
    if (String(authUser?.role_id) === '58') {
      return '/orders?status=All&search=&page=0&limit=10';
    }
  } catch (e) {
    // ignore parse errors and fall back to the default dashboard
  }
  return '/dashboard';
};

const userRoutes = [
  //dashboard
  { path: '/orders-dasboard', component: Dashboard },
  { path: '/dashboardd', component: Dashboardd },

  //orders
  { path: '/orderdashboard', component: OrderDashboard },
  { path: '/orders', component: Orders },
  { path: '/orders/create', component: OrderCreate },
  { path: '/orders/deliveryReport', component: DeliveryReport },
  { path: '/orders/deliveryReport/import', component: DeliveryReportUpload },
  {
    path: '/orders/deliveryReport/import-sprintx-courier',
    component: DeliveryReportUpload,
  },
  {
    path: '/orders/deliveryreport/import-sprintx-courier',
    component: DeliveryReportUpload,
  },
  {
    path: '/orders/deliveryReport/import-marketplace-stock-file',
    component: DeliveryReportUpload,
  },
  {
    path: '/orders/deliveryreport/import-marketplace-stock-file',
    component: DeliveryReportUpload,
  },
  { path: '/orders/qa', component: QaOrders },
  { path: '/orders/quotations', component: Quotations },
  { path: '/orders/quotations/create', component: CreateQuotation },
  { path: '/cscoupons/list', component: CsCoupons },
  { path: '/csdashboard/wishlist', component: WishlistIndex },

  // These must stay above /orders/:id, which matches case-insensitively and
  // would otherwise swallow both paths
  { path: '/Orders/payment-failed-orders', component: PaymentFailedOrders },
  { path: '/Orders/cod-return-orders', component: CodReturnOrders },

  { path: '/orders/:id', component: OrderDetails },
  { path: '/DeleteOrderDetails/:id', component: DeleteOrderDetails },
  { path: '/splitorders', component: splitOrders },
  { path: '/b2borders', component: b2bOrders },
  { path: '/kioskorders', component: kioskOrders },
  { path: '/installorders', component: b2bOrders },

  { path: '/bulkorders', component: bulkOrders },
  { path: '/bulkorders/:id', component: bulkDetails },
  { path: '/cncorders', component: cncOrders },
  { path: '/cncorders', component: cncDetails },
  { path: '/returnorders', component: ReturnOrders },
  { path: '/returnstoreorders', component: ReturnStoreOrders },
  { path: '/create-store-return', component: StoreOrders },

  { path: '/returnapprovedOrders', component: ReturnApprovedOrders },
  { path: '/returnmarketplace', component: ReturnMarketplace },

  { path: '/returnorders/:id/:order', component: ReturnDetails },
  { path: '/returnmarketorders/:id/:order', component: ReturnMarketDetails },

  { path: '/OrderLogReport/:ref', component: OrderLogReport },
  { path: '/DeleteOrders', component: DeleteOrders },

  // MarketPlace
  { path: '/marketplaceorders', component: marketplaceOrders },
  { path: '/marketplacesplitorders', component: marketplaceSplitOrders },

  { path: '/marketplaceorders/:id', component: MarketDetail },
  { path: '/marketplacesplitorders/:id', component: MarketSplitDetail },

  // ST Orders
  { path: '/storders', component: stOrders },
  { path: '/storders/:id', component: MarketSplitDetail },

  // carrefour MarketPlace
  { path: '/carorders', component: carrefourOrders },
  { path: '/carorders/:id', component: CarrefourSplitDetail },
  // { path: '/carorders/:id/edit', component: EditCarOrder },

  { path: '/importorders', component: ImportOrders },
  { path: '/importreturnorders', component: ImportReturnOrders },

  { path: '/marketPlacedashboard', component: MarketplaceDashboard },

  //returns
  { path: '/returns', component: Returns },
  { path: '/returns-dashboard', component: ReturnDashboard },
  { path: '/create-online-return', component: CreateFormReturn },
  { path: '/CreateFormStoreReturn', component: CreateFormStoreReturn },
  { path: '/CreateFormReturnWarehouse', component: CreateFormReturnWarehouse },
  { path: '/CreateCstReturnWarehouse', component: CreateCstReturnWarehouse },

  //profile
  { path: '/profile', component: userProfile },

  //dashboard
  { path: '/calendar', component: Calendar },
  { path: '/holiday-calendar', component: HolidayCalendar },

  { path: '/permission', component: Permissions },
  { path: '/UserForm', component: UserForm },
  { path: '/EditUserForm/:id', component: EditUserForm },
  { path: '/userRoleList', component: UserRoleList },
  { path: '/NewRoleForm', component: NewRoleForm },
  { path: '/EditNewRole/:id', component: EditNewRole },
  //Contact
  { path: '/contacts-profile', component: ContactsProfile },

  // Settings
  { path: '/mailSettings', component: MailSettings },
  { path: '/templateSettings', component: TemplateSettings },

  { path: '/ManageSettings', component: ManageSettings },
  { path: '/DeliverySettings/:id/:country', component: DeliverySettings },
  // Reivews
  { path: '/deliveryreviews', component: Reviews },
  { path: '/deliveryreviewsdetail/:ref', component: ReviewRatingDetail },

  //  callback
  { path: '/callback', component: Callback },
  { path: '/Callbackdetail/:id', component: Callbackdetail },

  // Manage Photoshoot
  { path: '/photoShoot', component: Photoshoot },
  { path: '/photoshootdetail/:id', component: PhotoDetails },

  // BCCW Orders
  { path: '/ManageRiverHillOrders', component: ManageRiverHillOrders },
  { path: '/RiverOrderDetails/:id', component: RiverHillOrderDetail },
  { path: '/CustomerTracking', component: CustomerTracking },
  { path: '/TrackingDetails/:id', component: TrackingDetails },

  { path: '/DesignYourHomeLead', component: DesignYourHomeLead },
  { path: '/HomeLeadDetails/:id', component: HomeLeadDetails },

  // Manage Refund
  // { path: '/ManageRefund', component: ManageRefunds },
  // { path: '/Refunds/manage-details', component: ManageRefundAmount },
  { path: '/Refunds/list', component: OrderRefunds },
  { path: '/Refunds/banklist', component: BankRefunds },
  { path: '/Refunds/store-refunds', component: StoreRefunds },

  // Complaints
  { path: '/Complaints/manage-complaints', component: ManageComplaints },
  { path: '/Complaints/manage-complaints/:id', component: ComplaintDetails },

  // Complaints DO
  { path: '/Complaints/complaint-do-list', component: ComplaintsDoList },
  { path: '/Complaints/complaint-do-form', component: ComplaintsDoPage },

  // Manage Service Orders
  { path: '/service-orders/dashboard', component: ServiceOrderDashboard },
  {
    path: '/service-orders/manage-service-orders',
    component: ManageServiceOrders,
  },
  {
    path: '/service-orders/manage-service-orders/:id',
    component: ServiceOrdersDetails,
  },
  { path: '/service-orders/item-master', component: ServiceItemMaster },
  { path: '/service-orders/non-sale-approvals', component: NonSaleApprovals },
  { path: '/service-orders/manage-to', component: ManageTO },
  { path: '/service-orders/manage-technicians', component: ManageTechnicians },
  { path: '/service-orders/service-feedback', component: ServiceFeedback },

  // Driver Analysis
  { path: '/driver-analysis', component: DriverAnalysis },

  // Manage Purifier Order
  { path: '/purifier-orders', component: ManagePurifierOrders },

  // Manage Donations
  { path: '/donations/manage-donations', component: ManageDonationsList },

  // Advance Posting
  { path: '/advance-posting/list', component: AdvancePostingListIndex },
  { path: '/premium-care/list', component: PremiumCareListIndex },

  //Manage Queue
  { path: '/queue', component: Queue },
  { path: '/rejected-queue', component: RejectedQueue },

  { path: '/queue-return', component: QueueReturn },

  { path: '/queue/notifications', component: NotificationManager },

  { path: '/ApprovalRefund1', component: ApprovalRefund },

  { path: '/importinstallationorders', component: ImportInstallationOrders },
  { path: '/installationorders', component: installationorders },

  //Customers
  { path: '/AllCustomer', component: AllCustomer },
  { path: '/AddCustomerForm', component: AddCustomerForm },
  { path: '/AddCustomerFormDetail/:id', component: AddCustomerFormDetail },
  { path: '/wallet-list', component: Wallet },
  // { path: '/wallet-list/:id', component: WalletDetails },
  {
    path: '/AddCustomerFormDetail/:uuid/:id',
    component: AddCustomerFormDetail,
  },

  // Manage Reports
  { path: '/reports', component: Reports },

  //  Non Planning Order
  { path: '/NonPlanningOrder', component: NonPlanningOrder },
  { path: '/NonServiceArea', component: NonServiceArea },
  { path: '/NonServicesAreaForm/:id', component: NonServicesAreaForm },
  { path: '/ClickandCollectList', component: ClickandCollectList },
  { path: '/ClickandCollect', component: ClickandCollect },
  { path: '/ClickandCollectForm/:id', component: ClickandCollectForm },
  { path: '/StoreConfig', component: StoreConfig },

  // this route should be at the end of all other routes
  { path: '/', exact: true, component: () => <Redirect to={getDefaultDashboard()} /> },

  // Product Feedback
  { path: '/ProductsFeedback', component: ProductsFeedback },
  { path: '/productFeedbackDetail/:id', component: ProductFeedbackDetail },
  // knowledge Base
  { path: '/Categories', component: KnowledgeBaseCategory },
  { path: '/AddNewCategoryForm', component: AddNewCategoryForm },
  { path: '/Articles', component: KnowledgeBaseArticles },
  { path: '/AddNewArticle', component: AddNewArticle },
  { path: '/EditNewArticle/:id', component: EditNewArticle },
  { path: '/KbUpdateCategoryForm/:id', component: KbUpdateCategoryForm },
  { path: '/KBDepartments', component: KBDepartments },
  { path: '/AddNewDepartment', component: AddNewDepartment },
  { path: '/EditDepartment/:id', component: EditDepartment },
  //  Import Export
  { path: '/ImportExport', component: ImportExport },
  { path: '/LsStockSkuList', component: LsStockSkuList },
  //Sms Settings Module
  { path: '/settings/notification', component: NotificationSettings },
  //Image Tools Module
  { path: '/tools/image-resize', component: ImageTools },

  // Orders Dashboard
  {
    path: '/dashboard',
    component: () => {
      try {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        if (authUser?.role_id === '51') {
          return <Redirect to="/service-orders/dashboard" />;
        }
      } catch (e) {
        // ignore parse errors and render the default dashboard
      }
      return <MainOrdersDashboard />;
    },
  },
  //Manage Invoices
  { path: '/manage-invoices', component: ManageInvoices },
  { path: '/exported-reports', component: ExportedReports },
];

const authRoutes = [
  //authencation page
  { path: '/logout', component: Logout },
  { path: '/login', component: Login },
  { path: '/forgot-password', component: ForgetPwd },
  { path: '/register', component: Register },
  { path: '/auth-lock-screen', component: LockScreen },
];

export { userRoutes, authRoutes };
